module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/uOy54D/media/FC-9781685623609.jpg?1701092724812",
      "alt": "This image is the cover for the book The 12"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The 12\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_vm._v("An outbreak of twelve gruesome, unsolved murders from the 1800s seems an excellent choice for Jay Dalton to try out his hand at writing. Doing so as he is starting life over after a painful divorce in a peaceful, rural farmhouse, in which he had recently moved, seems delightful. All would not stay as it seems for long.")]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_vm._v("The quaintness of his old farm house quickly fades as he becomes more aware that he isn’t alone in his new abode. A series of journals Jay discovers provide unexpected research results for his book, even as they seem to come more and more ominously to life. But it is a series of “accidents” that are most troublesome, as it seems that someone intends for Jay to never finish his book.")]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_vm._v("As Jay digs deeper, he begins to suspect that the unsolved murders, the hauntings in his house, and his current peril may be more closely connected than he would have ever suspected. How good he is at putting the pieces together may just determine if he lives to write about it. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tim Middlekauff\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("Tim Middlekauff, who hails from the Midwest, received a degree in marketing from Indiana University. Though his fondness for writing began in junior high, his penchant for story telling dates back earlier than that. These coupled to form a dream of one day writing a book of his own. His son’s life-threatening accident was the impetus for not delaying any further in bringing this dream to life. He hopes everyone who reads "), _c('em', [_vm._v("The 12")]), _vm._v(" enjoys it as much as he enjoyed telling the story.")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0